const APP_VERSION_KEY = "app_build_version";

export const checkAndClearCache = async (): Promise<boolean> => {
  try {
    const res = await fetch(`/meta.json?t=${Date.now()}`);
    const { version } = await res.json();

    const storedVersion = localStorage.getItem(APP_VERSION_KEY);

    if (storedVersion && storedVersion !== version) {
      // New deploy detected — clear everything
      localStorage.clear();
      sessionStorage.clear();

      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
      }

      // Store new version after clear
      localStorage.setItem(APP_VERSION_KEY, version);
      window.location.reload();
      return false;
    }

    // First visit or same version — store and proceed
    localStorage.setItem(APP_VERSION_KEY, version);
    return true;
  } catch {
    // On error (offline, fetch fail), don't block the app
    return true;
  }
};
